export default __webpack_public_path__ + "static/media/big-xin.f1b352c4.png";